module.exports = __webpack_public_path__ + "img/tis.9d9231c6.png";